import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft, Home, Building2, TrendingUp, BookOpen, Star, Briefcase, Rocket, Newspaper, Compass, Grid, Flame } from "lucide-react";
import Navbar from "../landing/Navbar";

const CATEGORIES = [
  { path: "/discover/startups", label: "Startups", icon: Rocket },
  { path: "/discover/incubators", label: "Incubators", icon: Building2 },
  { path: "/discover/vc-firms", label: "VC Firms", icon: TrendingUp },
  { path: "/discover/trending-startups", label: "Trending", icon: Flame },
  { path: "/discover/industries", label: "Explore Industries", icon: Compass },
  { path: "/discover/news", label: "News & Funding", icon: Newspaper },
  { path: "/discover/browse", label: "Browse Directory", icon: Grid },
  { path: "/discover/blog", label: "Startup Blog", icon: BookOpen },
  { path: "/discover/featured", label: "Featured Lists", icon: Star },
  { path: "/discover/hiring", label: "Hiring", icon: Briefcase },
];

export default function DiscoverLayout({ children, title, subtitle }) {
  const navigate = useNavigate();
  const location = useLocation();

  const getBreadcrumbs = () => {
    const parts = location.pathname.split("/").filter(Boolean);
    return (
      <div className="text-xs text-gray-500 flex items-center gap-2 mb-6 font-medium flex-wrap">
        <Link to="/" className="hover:text-[#7C3AED] transition flex items-center gap-1">
          <Home className="w-3.5 h-3.5" /> Home
        </Link>
        <span>/</span>
        <Link to="/discover" className="hover:text-[#7C3AED] transition">Discover</Link>
        {parts.length > 1 && (
          <>
            <span>/</span>
            <span className="text-gray-900 font-semibold capitalize">
              {parts[1].replace("-", " ")}
            </span>
          </>
        )}
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gray-50/40 flex flex-col flex-1 w-full">
      <Navbar onGetStarted={() => navigate("/")} />
      
      <main className="pt-28 pb-16 flex-1 w-full">
        <div className="w-full px-4 sm:px-5 md:px-8">
          {/* Breadcrumbs */}
          {getBreadcrumbs()}

          {/* Back Button */}
          <button
            onClick={() => navigate(location.pathname === "/discover" ? "/" : "/discover")}
            className="text-xs font-semibold text-gray-600 inline-flex items-center gap-1 hover:text-[#7C3AED] mb-6 transition"
            data-testid="discover-back"
          >
            <ArrowLeft className="w-3.5 h-3.5" /> {location.pathname === "/discover" ? "Back to Home" : "Discover Hub"}
          </button>

          {/* Header Block */}
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-6 mb-8">
            <div>
              <h1 className="font-display text-3xl md:text-4xl font-extrabold tracking-tighter text-gray-950 flex items-center gap-2">
                {title}
              </h1>
              {subtitle && <p className="text-xs text-gray-500 mt-1 max-w-2xl leading-relaxed">{subtitle}</p>}
            </div>
          </div>



          {/* Page Content */}
          <div className="w-full">
            {children}
          </div>
        </div>
      </main>
    </div>
  );
}
